export class ShipmentWaybillDemurrageAndDetentionInfoLoad {
  public static readonly type = '[ShipmentWaybillDemurrageAndDetentionInfo] Load Info';
  constructor(public payload: string) {}
}

export class ShipmentWaybillDemurrageAndDetentionInfoSetInitialState {
  public static readonly type = '[ShipmentWaybillDemurrageAndDetentionInfo] Set Initial State';
}
